import { render, staticRenderFns } from "./MediaTemplateUploader.vue?vue&type=template&id=efbfd3a4&scoped=true&"
import script from "./MediaTemplateUploader.vue?vue&type=script&lang=js&"
export * from "./MediaTemplateUploader.vue?vue&type=script&lang=js&"
import style0 from "./MediaTemplateUploader.vue?vue&type=style&index=0&id=efbfd3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbfd3a4",
  null
  
)

export default component.exports